// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__anAPO","vLegacy":"SelectSecondary_vLegacy__1xhNW","error":"SelectSecondary_error__33em-","disabled":"SelectSecondary_disabled__1h_EK"};